import NavBar from '../components/NavBar'
import HeroSection from '../components/MaintenanceTechnicalSupport/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/MaintenanceTechnicalSupport/ProcessSection'
import TechStackMarquee from '../components/MaintenanceTechnicalSupport/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const MaintenanceTechnicalSupport = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default MaintenanceTechnicalSupport